import React from 'react';
import { APP_URL } from '../lib/config';

const Footer: React.FC = () => {
  return (
    <footer className="bg-[#05282C] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Logo and Description */}
          <div className="col-span-1 md:col-span-2">
            <div className="mb-6">
              <img 
                src="/assets/images/convalytics-ai-horizontal-light.svg" 
                alt="ConvaLytics AI" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-white/90 mb-8 max-w-lg text-lg leading-relaxed">
              Transform your call center with AI-powered insights. Analyze 100% of your calls, 
              improve agent performance, and never miss a thing.
            </p>
            <div className="flex items-center space-x-2 text-white/90">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <a 
                href="mailto:support@convalyticsai.com" 
                className="hover:text-white transition-colors font-medium"
              >
                support@convalyticsai.com
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-semibold mb-6 text-white">Get Started</h3>
            <div className="space-y-4">
              <a 
                href={APP_URL} 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 bg-white/10 hover:bg-white/20 text-white px-6 py-3 rounded-lg transition-all duration-300 group"
              >
                <svg className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
                <span>Launch App</span>
              </a>
              <p className="text-white/80 text-sm">
                Ready to transform your call center operations?
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-16 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-white/80 text-sm mb-4 md:mb-0">
              © 2025 ConvaLytics AI. All rights reserved.
            </div>
            <div className="flex space-x-6 text-sm">
              <a href="#how-it-works" className="text-white/80 hover:text-white transition-colors">
                How It Works
              </a>
              <a href="#why-choose" className="text-white/80 hover:text-white transition-colors">
                Why Choose Us
              </a>
              <a href="#faq" className="text-white/80 hover:text-white transition-colors">
                FAQ
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
